<!--suppress JSValidateTypes -->
<style src='@/resources/styles/loading.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <div class='loader'>
        <div class='toHide'>
          <h1 id='status' class='status lead'>
            Loading results...
          </h1>

          <Spinner />
        </div>
      </div>
    </div>
  </main>
</template>

<script>

  import {mapActions, mapGetters} from 'vuex'
  import Spinner from "../../extended/Spinner";
  import Vote from "../../../Vote";

  export default {
    name: 'LoadExistingView',
    components: {Spinner},

    mounted: function() {
      this.pageLoaded(this.$route);

      const slug = this.$route.params['slug'];

      this.$store.commit("resetFilters"); //make sure filters are at defaults
      const filters = this.$store.getters.filters;
      filters.slug = slug;

      const payload = {filters: filters, router: this.$router};
      window.console.log("Payload:", payload);
      this.$store.dispatch("fetchResults", payload);
    },

    computed: {

      ...mapGetters(['state', "loadingStatus", "loadingProgress", "filters"]),
    },

    methods: {
      ...mapActions(['pageLoaded'])
    }
  }
</script>